import { all, call, fork, put, takeEvery } from "redux-saga/effects";

// actions
import { doneIndicator, error } from "../../actions/standardActions";

// api
import tradeRequestApi from "../../sources/api/tradeRequestApi";

// constants
import { FETCH_TRADE_OFFERS } from "../../constants/tradeOffersTypes";

// lib
import httpSaga from "../../lib/httpSaga";
import { tradeOffers } from "../../schemas/Normalizr";

export function* fetchTradeOffers(action) {
  if (action["@@redux-saga/SAGA_ACTION"]) return;

  const params = action.payload;

  try {
    yield* httpSaga(
      FETCH_TRADE_OFFERS,
      call(tradeRequestApi.fetchTradeOffers, params),
      tradeOffers
    );
  } catch (e) {
    yield put(error(FETCH_TRADE_OFFERS, e));
  } finally {
    yield put(doneIndicator(FETCH_TRADE_OFFERS));
  }
}

export function* watchFetchTradeOffers() {
  yield takeEvery(FETCH_TRADE_OFFERS, fetchTradeOffers);
}

export default function* root() {
  yield all([fork(watchFetchTradeOffers)]);
}



// WEBPACK FOOTER //
// ./app/sagas/tradeOffers/fetchTradeOffers.js